import Text from "@commons/Typography/Text";
import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import type { GeoJsonFeature } from "@typings/components/map";
import type { IndividualGeoJsonProperties } from "@services/individuals/getGeoJson/type";

interface IndividualPopupProps {
  feature: GeoJsonFeature<IndividualGeoJsonProperties>;
  onNavigate: (path: string) => void;
}

function IndividualPopup({ feature, onNavigate }: IndividualPopupProps) {
  if (!feature || !feature.properties) {
    return (
      <div className="p-3">
        <Text size="sm" className="text-red-500">
          Erro ao carregar dados
        </Text>
      </div>
    );
  }

  const individual = feature.properties;
  const coordinates = feature.geometry.coordinates;

  const handleNavigate = () => {
    onNavigate(`/individuals/${individual.id}`);
  };

  return (
    <div className="flex flex-col gap-3 px-4 py-3 min-w-[280px]">
      <div className="flex items-center justify-between">
        <Heading size="sm">Último registro</Heading>
        {!individual.hasGPS && (
          <Text
            customVariant="white"
            size="sm"
            className="bg-gray-500 px-2 py-1 rounded-2xl"
          >
            Sem GPS
          </Text>
        )}
      </div>

      <div className="space-y-2">
        {individual.lastLocationDate && (
          <Text size="sm" className="font-roboto">
            <span className="font-semibold">Data/Hora:</span>{" "}
            {new Date(individual.lastLocationDate).toLocaleString("pt-BR")}
          </Text>
        )}

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coordenadas:</span>{" "}
          {coordinates[1].toFixed(6)}, {coordinates[0].toFixed(6)}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Marcação:</span>{" "}
          {individual.marking || "N/A"}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Nome UFU:</span>{" "}
          {individual.ufuName || "N/A"}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Espécie:</span>{" "}
          {individual.species || "N/A"}
        </Text>
      </div>

      <Button
        size="auto"
        customVariant="secondary"
        className="mt-2"
        onClick={handleNavigate}
      >
        Mais Detalhes
      </Button>
    </div>
  );
}

export default IndividualPopup;
